// services/excelService.js
import api from './api';

export const exportReportsToExcel = async () => {
    try {
        // Backend'den Excel dosyasını blob olarak al
        const response = await api.get('/reports/export-excel', {
            responseType: 'blob'
        });

        // Excel dosyasını indir
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        // Dosya adını tarih ile oluştur
        const currentDate = new Date().toISOString().split('T')[0];
        link.setAttribute('download', `raporlar-${currentDate}.xlsx`);

        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        console.log('Excel dosyası başarıyla indirildi');
    } catch (error) {
        console.error('Excel export servisi hatası:', error);
        throw error;
    }
};

// Documents export fonksiyonu
export const exportDocumentsToExcel = async (filters = {}) => {
    try {
        console.log('📊 Documents Excel export başlatılıyor:', filters);

        // Filters'ı URLSearchParams'a dönüştür
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value && value !== '') {
                params.append(key, value);
            }
        });

        // Backend'den Excel dosyasını blob olarak al
        const response = await api.get(`/documents/admin/export?${params}`, {
            responseType: 'blob'
        });

        // Excel dosyasını indir
        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        // Dosya adını tarih ile oluştur
        const currentDate = new Date().toISOString().split('T')[0];
        link.setAttribute('download', `belgeler-${currentDate}.xlsx`);

        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);

        console.log('📊 Documents Excel dosyası başarıyla indirildi');
    } catch (error) {
        console.error('❌ Documents Excel export hatası:', error);
        throw error;
    }
};